import { render, staticRenderFns } from "./SaqGroup.vue?vue&type=template&id=157053e0"
import script from "./SaqGroup.vue?vue&type=script&lang=js"
export * from "./SaqGroup.vue?vue&type=script&lang=js"
import style0 from "./SaqGroup.vue?vue&type=style&index=0&id=157053e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports